import React, { useEffect, useState, useCallback } from "react";
import { updateUser, getAllUsers } from "./userService";
import { useNavigate, useParams } from "react-router-dom";

export default function EditUser() {
  const { id }   = useParams();
  const navigate = useNavigate();
  const [form, setForm] = useState(null);

  const loadUser = useCallback(async () => {
    const users = await getAllUsers();
    const found = users.find((u) => u.id === id);
    if (found) setForm(found);
  }, [id]);

  useEffect(() => { loadUser(); }, [loadUser]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm(prev => ({ ...prev, [name]: type === "checkbox" ? checked : value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    await updateUser(id, {
      name:   form.name,
      role:   form.role,
      phone:  form.phone || "",
      active: form.active,
      status: form.active ? "active" : "inactive",
    });
    navigate("/users");
  };

  if (!form) return <div className="p-6">Loading...</div>;

  const isTechnician = form.role === "technician";

  return (
    <div className="p-6 max-w-xl mx-auto">
      <h1 className="text-2xl font-bold mb-6">Edit User</h1>

      {/* Company — read only */}
      <div className="bg-slate-50 border border-slate-200 rounded p-3 mb-4 text-sm text-slate-600">
        🏢 Company: <strong>{form.company_name || form.company_id}</strong>
      </div>

      <form onSubmit={handleSubmit} className="space-y-4" autoComplete="off">

        {/* Name */}
        <div>
          <label className="block text-sm font-medium text-slate-600 mb-1">Full Name</label>
          <input
            type="text"
            name="name"
            autoComplete="off"
            className="border p-2 w-full rounded"
            value={form.name || ""}
            onChange={handleChange}
          />
        </div>

        {/* Role */}
        <div>
          <label className="block text-sm font-medium text-slate-600 mb-1">Role</label>
          <select
            name="role"
            className="border p-2 w-full rounded"
            value={form.role || ""}
            onChange={handleChange}
          >
            <option value="owner">Owner</option>
            <option value="sm">Service Manager</option>
            <option value="manager">Manager</option>
            <option value="technician">Technician</option>
            <option value="store">Store</option>
            <option value="accounts">Accountant</option>
          </select>
        </div>

        {/* Email — read only (not editable) */}
        {!isTechnician && (
          <div>
            <label className="block text-sm font-medium text-slate-600 mb-1">Email Address</label>
            <input
              type="email"
              className="border p-2 w-full rounded bg-slate-50 text-slate-400 cursor-not-allowed"
              value={form.email || ""}
              readOnly
              title="Email cannot be changed"
            />
            <p className="text-xs text-slate-400 mt-1">Email cannot be changed after account creation.</p>
          </div>
        )}

        {/* Phone — editable for technicians */}
        {isTechnician && (
          <div>
            <label className="block text-sm font-medium text-slate-600 mb-1">Mobile Number</label>
            <input
              type="tel"
              name="phone"
              autoComplete="off"
              className="border p-2 w-full rounded"
              value={form.phone || ""}
              onChange={handleChange}
              placeholder="9876543210"
            />
          </div>
        )}

        {/* Active toggle */}
        <label className="flex items-center gap-2 text-sm text-slate-600">
          <input
            type="checkbox"
            name="active"
            checked={form.active || form.status === "active"}
            onChange={handleChange}
          />
          Active User
        </label>

        <button
          type="submit"
          className="bg-blue-600 text-white px-4 py-2 rounded w-full font-semibold hover:bg-blue-700"
        >
          Update User
        </button>
      </form>
    </div>
  );
}
